import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { StateAction, lineSelector } from './line.action';
import { IdentityActionType, IdentityState, IdentityAction, InitialIdentity } from './action/identity.action';
import { CustomerActionType, CustomerState, CustomerAction, InitialCustomerAction } from './action/customer.action'
import { ChannelState, ChannelActionType, ChannelAction, InitialChannelAction } from './action/channel.action';
import { switchMap, map } from 'rxjs/operators';
import { Customer, Identity } from '../models/customer.model';
import { Channel } from '../models/channel.model';
@Injectable({
  providedIn: 'root'
})
export class LineStateActionService {

  private customerState: CustomerState = new CustomerState(null);
  private identityState: IdentityState = new IdentityState(null);
  private channelState: ChannelState = new ChannelState(null);
  public otpCount = 0;

  // Streamout data;
  observableCustomer: Observable<CustomerState>;
  observableIdentity: Observable<IdentityState>;
  observableChannel: Observable<ChannelState>;

  // Sinked in
  sinkCustomer: BehaviorSubject<CustomerAction> = new BehaviorSubject(new InitialCustomerAction());
  sinkIdentity: BehaviorSubject<IdentityAction> = new BehaviorSubject(new InitialIdentity());
  sinkChannel: BehaviorSubject<ChannelAction> = new BehaviorSubject(new InitialChannelAction());

  $stateAction: BehaviorSubject<any>;
  //private $selector: BehaviorSubject<string> = new BehaviorSubject(null);

  $store: Observable<any>;

  constructor() {
    // pip line action identity
    this.observableIdentity = this.sinkIdentity.pipe(
      switchMap(result => of(this.reducerIdentityAction(result)))
    );

    // pip line action channel
    this.observableChannel = this.sinkChannel.pipe(
      switchMap(result => of(this.reducerChannelAction(result)))
    );

    // pip line action customer
    this.observableCustomer = this.sinkCustomer.pipe(
      switchMap(result => of(this.reducerCustomerAction(result)))
    );

  }

  get customerStateInfo(): Customer {
    return this.customerState.getValue();
  }

  get identityStateInfo(): Identity {
    return this.identityState.getValue();
  }

  get channelStateInfo(): Channel {
    return this.channelState.getValue();
  }

  reducerCustomerAction(action: CustomerAction): CustomerState {
    switch (action.type) {
      case (CustomerActionType.INIT_CUSTOMER): {
        this.customerState = new CustomerState(action.payload);
        break;
      }
      case (CustomerActionType.SET_CUSTOMER): {
        this.customerState = new CustomerState(action.payload);
        break;
      }
      case (CustomerActionType.SET_FIRSTNAME): {
        this.customerState.setFirstname(action.payload.firstname);
        break;
      }
      case (CustomerActionType.SET_LASTNAME):
        this.customerState.setLastname(action.payload.lastname);
        break;
      default:
        console.log('out of case');
    }
    return this.customerState;
  }


  reducerIdentityAction(action: IdentityAction): IdentityState {
    switch (action.type) {
      case (IdentityActionType.INIT_IDENTITY): {
        this.identityState = new IdentityState(action.payload);
      }
      case (IdentityActionType.SET_IDENTITY): {
        this.identityState = new IdentityState(action.payload);
        break;
      }
      case (IdentityActionType.SET_IDCARD): {
        this.identityState.setIDCard(action.payload.id_card)
        break;
      }
      case (IdentityActionType.SET_PHONENUMBER): {
        this.identityState.setPhone(action.payload.phone_number);
        break;
      }
      case (IdentityActionType.SET_UPDATE_CHANEL_IDENTITY_FLAG): {
        this.identityState.setUpdateChanelIdentityFlag(action.payload.update_chanel_identity_flag);
        break;
      }
      default:
        console.log('out of case');
    }
    return this.identityState;
  }

  reducerChannelAction(action: ChannelAction): ChannelState {
    switch (action.type) {
      case (ChannelActionType.INIT_CHANNEL): {
        this.channelState = new ChannelState(action.payload);
        break;
      }
      case (ChannelActionType.SET_CHANNEL): {
        this.channelState = new ChannelState(action.payload);
        break;
      }
      case (ChannelActionType.SET_CHANNEL_IDENTITY): {
        this.channelState.setChannalIdentity(action.payload.channel_identity);
        break;
      }
      case (ChannelActionType.SET_ELECTRONIC_CHANNEL): {
        this.channelState.setElectronicChannel(action.payload.electronic_channel);
        break;
      }
      case (ChannelActionType.SET_APPICATION_CHANNEL_REF): {
        this.channelState.setApplicationChannelReference(action.payload.application_channel_reference);
        break;
      }
      default:
        console.log('out of case')
    }

    return this.channelState;
  }


}

